import { RegionShared } from "@1games-ru/region-shared";
import { FridgeShowRequest } from "@1games-ru/region-shared/dist/cef/requests/fridge";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useShowFridge() {
  const [fridgeInfo, setFridgeInfo] = useState<FridgeShowRequest | null>(null);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Fridge.FridgeShow,
      (data: typeof RegionShared.Cef.Requests.FridgeShowRequest) => {
        setFridgeInfo(data);

        return true;
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Fridge.FridgeShow);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Fridge.FridgeHide, () => {
      setFridgeInfo(null);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Fridge.FridgeHide);
    };
  }, []);

  return { isShow: !!fridgeInfo, fridgeInfo };
}
